import React from "react";
import Container from "@mui/material/Container";

export default function StaticContentPage(props) {
    return (
        <Container mt={10} m={5}>
            {props.content}
        </Container>
    )
}